import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
const AppDownloadCTAs = (props) => {
    const { hideAppDownloadCTA, imageURL, url } = props;
    return (_jsx("a", { className: clsx('iv-mt-10 iv-mb-5 iv-mx-auto', hideAppDownloadCTA), target: "_blank", rel: "noreferrer", href: url, children: _jsx("img", { src: imageURL, width: 119, height: 41 }) }));
};
export default AppDownloadCTAs;
